import React, { useEffect, useState } from "react";


export interface PageItemProps {
  name?: string
  path: string | null
  children?: React.ReactNode
  isDefault?: boolean
  PageRender?: React.FC
}

export interface IMicroContext {
  currentPath: string | null;
  setCurrentPath: (path: string | null) => void;
  currentParams : any;
  setCurrentPramas: (pramas: any) => void;
  backPage: string | null;
  setBackPage: (path: string | null) => void;
  backParams: any;
  setBackParams: (pramas: any) => void;


}

const MicroNavigatorContext = React.createContext< IMicroContext  |null>(null)

export const MicroNavigatorProvider = ({children}:{children?: React.ReactNode}) => {
  const [currentPath, setCurrentPath] = React.useState<string | null>(null)
  const [currentParams, setCurrentPramas] = React.useState<any>({})
  const [backPage, setBackPage] = React.useState<string | null>(null)
  const [backParams, setBackParams] = React.useState<any>({})


  const value = {
    currentPath,
    setCurrentPath,
    currentParams,
    setCurrentPramas,
    backPage,
    setBackPage,
    backParams,
    setBackParams

  }

  return (
    <MicroNavigatorContext.Provider value={value}>
      {children}
    </MicroNavigatorContext.Provider>
  )
}

export const useMicroNavigator = () => {
  const context = React.useContext(MicroNavigatorContext)
  if (!context) {
    throw new Error('useMicroNavigator must be used within a MicroNavigatorProvider')
  }

  const navigate = (path: string | -1, params?: any) => {

    if (path === -1){
      context.setCurrentPath(context.backPage)
      context.setCurrentPramas(context.backParams)

    }else{
      context.setBackPage(context.currentPath)
      context.setBackParams(context.currentParams)
      context.setCurrentPath(path )
      context.setCurrentPramas(params)
    }


    
  }

  
  return {
    currentPath: context.currentPath,
    navigate,
    currentParams: context.currentParams
  }
}

export const PageItem = ({name, path, isDefault, children, PageRender } : PageItemProps) => {
  const { currentPath } = useMicroNavigator()
  const [isActive, setIsActive] = useState(false)

  useEffect(() => {
    
    if ((currentPath === null) && isDefault) {
    
      setIsActive(true)
    }else{
      setIsActive(currentPath === path)
    }

  }, [currentPath])// eslint-disable-line

  if (!isActive) {
    return <></>
  }

  if(PageRender){
    return <PageRender />
  }
  return (
    <>
      {children}
    </>
  )
}

